import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from "lucide-react";

export default function CaseStudyResults({ results }) {
  const { t } = useTranslation();

  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-20" aria-labelledby="results-heading">
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4" aria-hidden="true">
        // RESULTS
      </div>
      <h2 id="results-heading" className="font-display text-3xl md:text-4xl uppercase leading-tight mb-4">
        Measurable<br /><span className="text-amber-500">impact.</span>
      </h2>
      <p className="text-zinc-400 text-base max-w-2xl mb-12">
        The numbers speak for themselves. Here's what changed after deploying Max OS Cloud.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-900">
        {results.map((r, i) => (
          <div
            key={i}
            className="relative bg-[#09090B] p-8 text-center group hover:bg-zinc-950/80 transition-all duration-300"
          >
            {/* Hover corner accent */}
            <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <ArrowUpRight className="w-4 h-4 text-amber-500/50" />
            </div>

            <div className="font-display text-4xl md:text-5xl text-amber-500 uppercase mb-3 group-hover:scale-105 transition-transform duration-300">
              {r.value}
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400 group-hover:text-zinc-300 transition-colors duration-300">
              {r.label}
            </div>

            {/* Bottom accent line */}
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-0 h-[2px] bg-amber-500 group-hover:w-12 transition-all duration-300" />
          </div>
        ))}
      </div>
    </section>
  );
}
